module.exports = __webpack_public_path__ + "static/media/11-6.57459c3c.mp3";